import {
  UNASSIGNED_COACH_BUCKET,
  UNASSIGNED_COURT_BUCKET,
} from '@/utils/scheduleOccurrences';

export function computeTargetCourtIds(
  currentCourtIds: string[],
  targetColumnKey: string,
  sourceCourtId?: string
): string[] {
  if (targetColumnKey === UNASSIGNED_COURT_BUCKET) {
    if (sourceCourtId) {
      return currentCourtIds.filter((id) => id !== sourceCourtId);
    }
    return [];
  }
  if (sourceCourtId && sourceCourtId !== targetColumnKey) {
    return currentCourtIds.map((id) => (id === sourceCourtId ? targetColumnKey : id));
  }
  if (!currentCourtIds.includes(targetColumnKey)) {
    if (sourceCourtId) {
      return currentCourtIds.map((id) => (id === sourceCourtId ? targetColumnKey : id));
    }
    return [targetColumnKey];
  }
  return currentCourtIds;
}

export function computeTargetCoachIds(
  currentCoachIds: string[],
  targetColumnKey: string,
  sourceCoachId?: string
): string[] {
  if (targetColumnKey === UNASSIGNED_COACH_BUCKET) {
    if (sourceCoachId) {
      return currentCoachIds.filter((id) => id !== sourceCoachId);
    }
    return [];
  }
  if (sourceCoachId && sourceCoachId !== targetColumnKey) {
    return currentCoachIds.map((id) => (id === sourceCoachId ? targetColumnKey : id));
  }
  if (!currentCoachIds.includes(targetColumnKey)) {
    if (sourceCoachId) {
      return currentCoachIds.map((id) => (id === sourceCoachId ? targetColumnKey : id));
    }
    return [...currentCoachIds, targetColumnKey];
  }
  return currentCoachIds;
}

export function haveSameIdSet(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((id, index) => id === sortedB[index]);
}
